import React from "react";
import "./styles/ButtonComponent.css";

function ButtonComponent({
  className,
  buttonTitle,
  buttonText,
  onClick,
  children,
  disabled,
}) {
  return (
    <button
      title={buttonTitle}
      type="button"
      disabled={disabled}
      className={`themes__form-inputbtn ${className ? className : ""}`}
      onClick={onClick}
    >
      {children || buttonText}
    </button>
  );
}

export default ButtonComponent;
